export default __webpack_public_path__ + "static/media/linea-ecommerce-10.dc1f09ac.ttf";